import Sales from '../assets/careers/financial-sales.jpg';
import Business from '../assets/careers/business-analyst.jpg';
const jobs = [
  {
    id: 1,
    slug: 'financial-sales',
    image: Sales,
  },
  {
    id: 2,
    slug: 'business-analyst',
    image: Business,
  },
];

export default jobs;